const H2 = ({children}) => (
  <h2 tw="text-lg text-brand font-semibold">{children}</h2>
)

export default H2
